import { authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

export function postAgent19(params) {
  return authPost(`${baseUrl}/Agent19.ashx`, params);
}
